import Component from "@glimmer/component";
import { LinkTo } from "@ember/routing";
import dIcon from "discourse/helpers/d-icon";
import { i18n } from "discourse-i18n";

export default class UserCircleNavItem extends Component {
  static shouldRender(args, context, owner) {
    return owner.lookup("service:circles")?.userCanUseCircles;
  }

  <template>
    <li class="user-nav__circles">
      <LinkTo @route="user.circles">
        {{dIcon "discourse_circles"}}
        <span>{{i18n "discourse_circles.user.circles"}}</span>
      </LinkTo>
    </li>
  </template>
}
